import { createContext } from "react";
import { Shift, DialogHandles, DialogId, DialogHandle, ProcessedTableLayout, Screen, Product, VenueData, SafeVenueData, Shortcut } from "../types";
import { DEFAULT_SHIFTS, DEFAULT_VENUE_DATA, DEFAULT_TABLE_MAP_HANDLE, DEFAULT_DIALOG_HANDLES, DEFAULT_BOOKING, DEFAULT_FORCED_RENDERS, DEFAULT_PROCESSED_TABLE_LAYOUT, DEFAULT_SCREEN, DEFAULT_PRODUCTS, DEFAULT_ROUTE, DEFAULT_SHORTCUTS } from "../utils/symbols";
import { TableLayoutHandle } from "../components/table-layout/TableLayout";
import { Booking } from "../utils/booking";

interface AppContextType {state: GlobalState; actions: GlobalActions}

interface GlobalState {
    booking: Booking
    shifts: Shift[]
    screen: Screen
    forcedRenders: number
    tableMapHandle: TableLayoutHandle
    dialogHandles: DialogHandles
    products: Product[]
    venueData: VenueData
    route: string
    shortcuts: Map<string, Shortcut>
    layout: ProcessedTableLayout
    mapVisible: boolean
}
interface GlobalActions {
    updateShifts: (data: Shift[]) => void
    updateScreen: (data: UIEvent) => void
    updateTableMapHandle: (data: TableLayoutHandle) => void,
    addDialogHandle: (id:DialogId, data: DialogHandle) => void
    updateProducts: (data: Product[]) => void
    forceRender: () => void
    updateVenueData: (venueData: SafeVenueData) => void
    navigate: (route: string) => void
    genericError: (retryFnc: () => void) => void
    addShortcuts: (shortcut: Shortcut[]) => void
    updateLayout: (data: ProcessedTableLayout) => void
    setMapVisible: React.Dispatch<React.SetStateAction<boolean>>
}

const AppContext = createContext<AppContextType>({
    state: {
        booking: DEFAULT_BOOKING,
        forcedRenders: DEFAULT_FORCED_RENDERS,
        shifts: DEFAULT_SHIFTS,
        screen: DEFAULT_SCREEN,
        tableMapHandle: DEFAULT_TABLE_MAP_HANDLE,
        dialogHandles: DEFAULT_DIALOG_HANDLES,
        products: DEFAULT_PRODUCTS,
        venueData: DEFAULT_VENUE_DATA,
        route: DEFAULT_ROUTE,
        shortcuts: DEFAULT_SHORTCUTS,
        layout: DEFAULT_PROCESSED_TABLE_LAYOUT,
        mapVisible: false,
    },
    actions: {
        updateShifts: (data) => {},
        updateScreen: (data) => {},
        updateProducts: (data) => {},
        updateTableMapHandle: (data) => {},
        addDialogHandle: (id, data) => {},
        forceRender: () => {},
        updateVenueData: (data) => {},
        navigate: (route) => {},
        genericError: (retryFnc) => {},
        addShortcuts: (shortcuts) => {},
        updateLayout: (data) => {},
        setMapVisible: (data) => {}
    }
})

export {AppContext}
export type {AppContextType}
